// src/pages/Productpage.js
import React from "react";
import { Helmet } from "react-helmet";
import topimage from "../../images/Discover.jpg";
import "../Products/productspage.css";
import {
  BoxesContainer,
  StatsStrip,
  ContactBanner,
  ProductsHeader,
} from "./Box";
import productpagebanner from "../../images/settingnewstandards.jpg"

const Productpage = () => {
  return (
    <>
      <Helmet>
        <title>Products | Sabiote</title>
      </Helmet>

      {/* Hero Section */}
      <div className="hero-ban">
        <div className="products-hero-banner">
        <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),`,
        }}
      >
            <h1 className="homepage-hero-title">
              Explore Our Healthcare Product Ecosystem
            </h1>
            <p className="homepage-hero-subtext">
              From infection control to orthopedic care — tailored for India’s
              surgical & clinical needs.
            </p>
            <div className="homepage-hero-buttons">
              <a href="#product-blocks" className="homepage-btn-outline">
                View Products
              </a>
            </div>
          </section>
        </div>
      </div>

      {/* Product Content Sections */}
      <div id="product-blocks" className="both-wrap">
        <ProductsHeader />
        <BoxesContainer />
        <StatsStrip />
      </div>
      <ContactBanner />
    </>
  );
};

export default Productpage;
